import { Route, Routes } from "react-router-dom";
import Home from "./Pages/home";
import Detail from "./Pages/detail";
import NotFound from "./Pages/notFound";
import CreateData from "./Pages/createData";
import Login from "./Pages/login";
import EditData from "./Pages/editData";
import SearchResult from "./Pages/searchResult";

export default function App() {
  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("wilayah");
  });

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route exact path="/detail/:id" element={<Detail />} />
        <Route
          exact
          path="/property/search/:query"
          element={<SearchResult />}
        />
        <Route exact path="/create" element={<CreateData />} />
        <Route exact path="/edit/:id" element={<EditData />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
